import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { cancelRemoteAction } from '../actions/remoteactions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from '../store'

import RemoteActionStatusBadge from './RemoteActionStatusBadge'
import LoadingProgress from './LoadingProgress'

class RemoteActionsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      deleting: false,
      deleteConfirmShown: false,
      deleteId: null,
      result: '',
      resultShown: false
    }

    this.resultToggle = this.resultToggle.bind(this)
    this.resultShow = this.resultShow.bind(this)
    this.delete = this.delete.bind(this)
    this.deleteConfirmShow = this.deleteConfirmShow.bind(this)
    this.deleteConfirmToggle = this.deleteConfirmToggle.bind(this)
  }

  delete() {
    const { cancelRemoteAction } = this.props

    this.setState({ deleting: true, deleteConfirmShown: false })
    cancelRemoteAction(this.state.deleteId)
  }

  deleteConfirmShow(id) {
    this.setState({
      deleteConfirmShown: true,
      deleteId: id
    })
  }

  deleteConfirmToggle() {
    this.setState({ deleteConfirmShown: !this.state.deleteConfirmShown })
  }

  resultToggle() {
    this.setState({ resultShown: !this.state.resultShown })
  }

  resultShow(result, e) {
    this.setState({ result: result, resultShown: true })
  }

  render() {

    const { remoteActions } = this.props;

    if (remoteActions.loading) {
      return <LoadingProgress />;
    }

    if (remoteActions.error) {
      return (<h2>Error al cargar las acciones remotas</h2>);
    }

    // Ensure remoteActions is an array before mapping
    const actionsList = Array.isArray(remoteActions.remoteActions) ? remoteActions.remoteActions : [];


    return (
      <div className="mt-5 remote-actions-list">
        <div className="table-responsive" style={{overflowX: 'auto', WebkitOverflowScrolling: 'touch'}}>
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Fecha/Hora</th>
                <th scope="col">Código</th>
                <th scope="col">Argumentos</th>
                <th scope="col">Estado</th>
                <th scope="col">Ejecutor</th>
                <th scope="col">Resultado</th>
                <th scope="col">Cancelar</th>
              </tr>
            </thead>
            <tbody>
              {actionsList.map(remoteAction => (
                <tr key={remoteAction._id}>
                  <td>
                    {(new Date(remoteAction.date)).toLocaleString()}
                  </td>
                  <td>{remoteAction.code}</td>
                  <td>
                    <tt>{remoteAction.arguments}</tt>
                  </td>
                  <td>
                    <RemoteActionStatusBadge status={remoteAction.status} />
                  </td>
                  <td>{remoteAction.executor}</td>
                  <td>
                    <button className="btn btn-vw"
                      onClick={e => this.resultShow(remoteAction.result, e)}>
                      <i className="fas fa-eye"></i>
                    </button>
                  </td>
                  <td>
                    <button className="btn btn-danger" onClick={() => this.deleteConfirmShow(remoteAction._id)}>
                      <i className="fas fa-cross"></i>
                    </button>
                  </td>
                </tr>
              )
              )}
            </tbody>
          </table>
        </div>
        <Modal isOpen={this.state.resultShown}>
          <ModalHeader toggle={this.resultToggle}>Resultado</ModalHeader>
          <ModalBody>
            <p className="text-break text-monospace">
              {this.state.result}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.resultToggle}>Cerrar</Button>
          </ModalFooter>
        </Modal>
        {/* Confirm deletion */}
        <div>
          <Modal isOpen={this.state.deleteConfirmShown}
            toggle={this.deleteConfirmToggle}>
            <ModalHeader toggle={this.deleteConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de cancelar la acción remota?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.delete}>
                Si
              </Button>
              <Button color="secondary" onClick={this.deleteConfirmToggle}>
                No
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  remoteActions: state.remoteactions
})

const mapDispatchToProps = dispatch => ({
  cancelRemoteAction: bindActionCreators(cancelRemoteAction, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(RemoteActionsList)

